import React from 'react';
import { FormattedMessage } from 'react-intl';
import NegativeToast from '@/components/toasts/NegativeToast';

const UsergroupRemoveSuccessToast = ({ group, user }) => (
  <NegativeToast className="aridhia-usergroup-remove-success-toast">
    <FormattedMessage id="usergroup.user.removal" values={{ userName: user.name, groupName: group.name }} />
  </NegativeToast>
);

export default UsergroupRemoveSuccessToast;
